<template>
  <div>
    <template>
      <div class="mt-3" style="text-align: -webkit-right">
        <v-btn @click="showSearch" color="primary">
          <v-icon>search</v-icon>{{ $t('advanced search') }}</v-btn
        >
      </div>
      <!-- <div class="text-xs-right">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div> -->
      <v-data-table
        :loading="loading"
        v-model="selected"
        :headers="headers"
        :items="data"
        :pagination.sync="pagination"
        item-key="name"
        class="elevation-1 mt-3"
      >
        <!-- hide-actions -->
        <template v-slot:items="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td v-if="props.item.first_name">
              {{ props.item.first_name }} {{ props.item.last_name }}
            </td>
            <td v-else>-</td>

            <td>{{ props.item.customerid || '-' }}</td>
            <td>{{ props.item.phoneno || '-' }}</td>
            <td>{{ props.item.email || '-' }}</td>
            <td>{{ props.item.address || '-' }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="searchDialog" persistent width="650px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="searchDialog = false" icon> <v-icon>close</v-icon></v-btn>
        </div>
        <div class="px-3 pb-4">
          <v-layout row wrap>
            <v-flex xs12 class="form-control">
              <div>ชื่อลูกค้า</div>
              <input v-model="filter.name" type="text" />
            </v-flex>
            <v-flex xs6 class="form-control pr-1">
              <div>{{ $t('customer_id') }}</div>
              <input v-model="filter.customerid" type="text" />
            </v-flex>
            <v-flex xs6 class="form-control pl-1">
              <div>เบอร์โทรศัพท์</div>
              <input v-model="filter.phoneno" type="text"
            /></v-flex>
            <v-flex xs12 class="form-control">
              <div>ที่อยู่</div>
              <input v-model="filter.address" type="text"
            /></v-flex>
          </v-layout>
          <div class="text-xs-center px-5">
            <v-btn :loading="loading" @click="onSearch" color="primary" depressed block>{{
              $t('Search')
            }}</v-btn>
            <v-btn @click="clearSearch" block flat>{{ $t('Clear Search') }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data: () => ({
    total: 0,
    offset: 0,
    limit: 10,
    pagetmp: 1,
    pageNumber: 1,
    search: '',
    detailToggle: false,
    pagination: {
      rowsPerPage: 25
    },
    selected: [],
    headers: [
      { text: 'ชื่อ', value: 'name', width: '5%', sortable: false },
      { text: 'รหัสลูกค้า', value: 'customerid', width: '1%', sortable: false },
      { text: 'เบอร์ติดต่อ', value: 'phoneno', width: '1%', sortable: false },
      { text: 'อีเมล', value: 'email', width: '1%', sortable: false },
      { text: 'ที่อยู่', value: 'address', width: '1%', sortable: false }
    ],
    data: [],
    filter: {
      name: '',
      customerid: '',
      phoneno: '',
      address: ''
    },
    searchDialog: false,
    loading: false
  }),
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData()
  },
  methods: {
    onSearch() {
      this.searchDialog = false
      this.getData()
    },
    showSearch() {
      this.searchDialog = true
    },
    clearSearch() {
      this.filter = {
        name: '',
        customerid: '',
        phoneno: '',
        address: ''
      }
      this.getData()
      this.searchDialog = false
    },
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        name: this.filter.name,
        customerid: this.filter.customerid,
        phoneno: this.filter.phoneno,
        address: this.filter.address
      }
      api.kingkitchengetcustomer(data, (err, response) => {
        this.data = response.data
        this.loading = false
      })
    },
    closeDetailToggle() {
      this.detailToggle = false
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/member/Customers.vue